import { Component, OnInit, Input } from '@angular/core';
import {InitProvider} from '../../../init-provider';

@Component({
  selector: 'app-theme-dark-logo',
  templateUrl: './ThemeDarkLogo.component.html',
  styleUrls: ['./ThemeDarkLogo.component.scss']
})
export class ThemeDarkLogoComponent implements OnInit {

  @Input() logoClass: any;

  public path;

  constructor(initProvider: InitProvider) {
    this.path = initProvider.getSettings().logo.medium;
  }

  ngOnInit() {}
}
